
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_ob1ul_93",
  "button": "awsui_button_fvjdu_ob1ul_111",
  "dots": "awsui_dots_fvjdu_ob1ul_112",
  "button-disabled": "awsui_button-disabled_fvjdu_ob1ul_134",
  "arrow": "awsui_arrow_fvjdu_ob1ul_139",
  "page-number": "awsui_page-number_fvjdu_ob1ul_149",
  "button-current": "awsui_button-current_fvjdu_ob1ul_155",
  "page-item": "awsui_page-item_fvjdu_ob1ul_170",
  "root-disabled": "awsui_root-disabled_fvjdu_ob1ul_186"
};
  